import { object, string } from "yup";
import { Admin } from "./types";

export const getValidation = (initialValues: Admin) => {
  const validationSchema = object({
    firstName: string()
      .required()
      .default(""),
    lastName: string()
      .required()
      .default(""),
    email: string()
      .required()
      .email("Invalid email.")
      .trim()
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({
      ...initialValues,
      image: initialValues.image?._id
    })
  };
};
